export default "__VITE_ASSET__BUrwYdxt__"